export const COLUMN_GROUP_ID_SEPARATOR = '>->';
